import { render, staticRenderFns } from "./OpeningHoursOrdinaryDayCard.vue?vue&type=template&id=2c22f080&scoped=true&"
import script from "./OpeningHoursOrdinaryDayCard.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursOrdinaryDayCard.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursOrdinaryDayCard.vue?vue&type=style&index=0&id=2c22f080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22f080",
  null
  
)

export default component.exports